import { connect } from 'react-redux';
import ThreadWindow from '../components/ThreadWindow';

const mapStateToProps = (state,ownProps) => ({
  threads: state.threads,
  begun: state.begun
});

export default connect(mapStateToProps)(ThreadWindow);
